import { render } from "./darkBackground.vue?vue&type=template&id=c38c9814"
import script from "./darkBackground.vue?vue&type=script&lang=js"
export * from "./darkBackground.vue?vue&type=script&lang=js"

import exportComponent from "/Volumes/Projekte/Seminarplattform/lernplattform-holistic-institut/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__